// extracted by mini-css-extract-plugin
module.exports = {"root":"_1cb049","imageLabel":"_577868","textLabel":"_59d240","disabled":"_27f98c","ratingLabel":"_7fddf0","textLabelRoot":"_7516ca","secondary":"_e9633b"};